var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 366,
    viewBox: "0 0 366 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.189 131.056H130.811V234H235.189V131.056Z",
    fill: "url(#paint0_linear_6772_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.811 112.167H235.088V111.657H357.435V10.1667H130.811V112.167Z",
    fill: "url(#paint1_linear_6772_3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 355.833H235.189V253.833H7.625V355.833Z",
    fill: "url(#paint2_linear_6772_3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.063 10.1667H7.625V234.944H111.063V10.1667Z",
    fill: "url(#paint3_linear_6772_3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M358.375 131.056H254.937V355.833H358.375V131.056Z",
    fill: "url(#paint4_linear_6772_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6772_3",
    x1: 311.791,
    y1: 128.88,
    x2: 311.791,
    y2: 355.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6772_3",
    x1: 311.791,
    y1: 128.88,
    x2: 311.791,
    y2: 355.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6772_3",
    x1: 311.791,
    y1: 128.88,
    x2: 311.791,
    y2: 355.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6772_3",
    x1: 311.791,
    y1: 128.88,
    x2: 311.791,
    y2: 355.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6772_3",
    x1: 311.791,
    y1: 128.88,
    x2: 311.791,
    y2: 355.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.abb497bbbd1936301ecc8cd13d2b04c4.svg";
export { ForwardRef as ReactComponent };